const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.payload };
        case 'saving':
            return { ...state, isSaving: true };
        case 'saved':
            return { ...state, isSaving: false };
        case 'showErrors':
            return { ...state, showErrors: true };
        case 'hideErrors':
            return { ...state, showErrors: false };
        default:
            return state;
    }
};

export default reducer;
